var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('casesHeder'),_vm._v(" "),(_vm.popUp_)?_c('popUpwindow',{attrs:{"lin_k":_vm.link_,"codeid":_vm.codeid,"cate2":_vm.cate2},on:{"close1":_vm.close1}}):_vm._e(),_vm._v(" "),_c('casesCennert',{on:{"handleChange":_vm.changeName}}),_vm._v(" "),_c('paheFooter')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-713c635e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/cases.vue
// module id = null
// module chunks = 